/**
 * tasksChanged — RW-2867: "a task just changed", for the nav badge.
 *
 * My Tasks' badge (App.js, useTaskInboxRead pollMs) re-reads the one task
 * inbox every few minutes; a screen that changes a task calls
 * announceTasksChanged() so the count moves now instead. A plain window event,
 * no imports, so any screen can call it without pulling in the deals service.
 */
export const TASKS_CHANGED_EVENT = 'reve:tasks-changed';

/** A screen changed a task: the badge re-reads now instead of on its next tick. */
export function announceTasksChanged() {
  try { window.dispatchEvent(new Event(TASKS_CHANGED_EVENT)); } catch (_) { /* no window */ }
}
